/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantContactsViewModel } from '../../models/merchant-contacts-view-model';

export interface UpdateMerchantContact$Params {
  merchantId: string;
      body: MerchantContactsViewModel
}

export function updateMerchantContact(http: HttpClient, rootUrl: string, params: UpdateMerchantContact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateMerchantContact.PATH, 'put');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateMerchantContact.PATH = '/merchants/{merchantId}/contacts';
